<template>
  <div class="iot-monitor-wrapper">
    <ChartBox title="物联感知监控" :tip="true">
      <div class="iot-container">
        <i
          class="el-icon-info"
          style="
            cursor: pointer;
            font-size: 23px;
            position: absolute;
            left: 110px;
            top: -40px;
          "
          title="帮助信息"
          @click="handleHelp()"
        ></i>

        <!-- 无数据提示 -->
        <div
          v-if="allItems.length === 0"
          class="no-data"
        >
          <img
            src="../assets/image/NoImg.png"
            alt="无数据"
            class="no-data-img"
          />
          <div class="no-data-text">暂无物联设备数据</div>
        </div>

        <!-- 轮播显示：所有数据放在一起，每页显示3组（6个卡片） -->
        <div
          v-if="pagesWithGroups.length > 0"
          class="iot-carousel-display"
        >
          <el-carousel
            class="iot-carousel"
            :height="carouselHeight"
            indicator-position="none"
            :autoplay="true"
            :interval="5000"
          >
            <el-carousel-item
              v-for="(page, pageIndex) in pagesWithGroups"
              :key="'page-' + pageIndex"
            >
              <div class="carousel-page">
                <div
                  v-for="(item, itemIndex) in page.items"
                  :key="itemIndex"
                  class="iot-card"
                >
                  <div class="tech-border-glow"></div>
                  <img
                    :src="getIconSrc(item.name)"
                    class="iot-icon-box"
                    alt="icon"
                  />
                  <div class="iot-name">{{ item.name }}</div>
                  <div v-if="item.location" class="iot-location">{{ item.location }}</div>
                  <div v-else-if="item.address" class="iot-location">{{ item.address }}</div>
                  <div v-if="item.type === 'status'" class="iot-status-only">
                    <span
                      class="status-value-big"
                      :class="getStatusColor(item.statusClass)"
                    >
                      {{ item.value }}
                    </span>
                    <span v-if="item.name =='油锅温度'" 
                      style="font-size: 17px;"
                      :class="getStatusColor(item.statusClass)"> {{ item.num }}℃</span>
                  </div>
                  <div v-else-if="item.type === 'value'" class="iot-value-box">
                    <div class="big-num digital-font">
                      {{ item.value }}<span class="unit">{{ item.unit }}</span>
                    </div>
                  </div>
                  <div v-else-if="item.type === 'temp-hum'" class="iot-temp-hum-box">
                    <div class="temp-hum-item">
                      <span class="th-label">温度</span>
                      <span class="th-value digital-font" :class="getStatusColor2(item.status)">
                        {{ item.temp }}<small>℃</small>
                      </span>
                    </div>
                    <div class="th-divider"></div>
                    <div class="temp-hum-item">
                      <span class="th-label">湿度</span>
                      <span class="th-value digital-font" :class="getStatusColor2(item.status)">
                        {{ item.hum }}<small>%</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </ChartBox>

    <el-dialog
      title="物联设备说明"
      :visible.sync="dialogVisible"
      width="500px"
      center
    >
      <div class="help-content">
        <h3>设备类型说明</h3>
        <table class="simple-table">
          <thead>
            <tr>
              <th>设备类型</th>
              <th>说明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>温度监测</td>
              <td>各仓库、后厨的温度数据</td>
            </tr>
            <tr>
              <td>水浸监测</td>
              <td>仓库水浸报警监测</td>
            </tr>
            <tr>
              <td>油锅温度</td>
              <td>后厨油锅温度监测</td>
            </tr>
            <tr>
              <td>紫外线灯</td>
              <td>消毒紫外线灯状态监测</td>
            </tr>
            <tr>
              <td>二氧化碳</td>
              <td>后厨CO2浓度监测</td>
            </tr>
            <tr>
              <td>动火离人</td>
              <td>动火设备离人监测</td>
            </tr>
            <tr>
              <td>燃气监测</td>
              <td>燃气泄漏监测</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
import { getIotInfo2 } from "../api/api";
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {
      iotData: {
        temp: [],         // 温度
        water: [],        // 水浸
        oil: [],          // 油锅
        ultraviolet: [],  // 紫外线
        co2: [],          // 二氧化碳
        fireNoPerson: [], // 动火离人
        jiawan: []        // 燃气
      },
      dialogVisible: false,
      cleanUpMemory: null,
      carouselHeight: '210px'
    };
  },
  components: {
    ChartBox
  },
  mixins: [myMixin],
  computed: {
    // 合并所有类型的数据为一个扁平数组
    allItems() {
      let result = [];
      Object.keys(this.iotData).forEach(type => {
        result = [...result, ...this.iotData[type]];
      });      
      return result;
    },
    // 将所有数据分页，每页3组（6个卡片）
    pagesWithGroups() {
      const pages = [];
      const items = this.allItems;

      for (let i = 0; i < items.length; i += 3) {
        const pageItems = items.slice(i, i + 3);
        pages.push({
          items: pageItems,
          totalCount: pageItems.length
        });
      }
      console.log('pagesWithGroups', pages);

      return pages;
    }
  },
  mounted() {
    this.getIotInfo2();
    this.cleanUpMemory = setInterval(() => {
      this.getIotInfo2();
    }, 180000);
  },
  beforeDestroy() {
    if (this.cleanUpMemory) {
      clearInterval(this.cleanUpMemory);
    }
  },
  methods: {
    handleHelp() {
      this.dialogVisible = true;
    },

    async getIotInfo2() {  
      try {
        const res = await getIotInfo2();

        // 检查响应数据是否存在
        if (!res || !res.data || !res.data.data) {
          console.warn('IoT数据响应格式不正确');
          return;
        }

        const data = res.data.data;
        console.log(res,'温度');
        

        // 处理温度数据（temp）
        if (data.temp && Array.isArray(data.temp) && data.temp.length > 0) {
          this.iotData.temp = data.temp.map(item => ({
            name: '温湿度',
            address: item.name || '',
            type: 'temp-hum',
            temp: item.temp || '--',
            hum: item.wet || '--',
            status: item.temp_status || '正常',
            unit: '',
            location: item.location || ''
          }));
        }

        // 处理水浸数据（water）
        if (data.water && Array.isArray(data.water) && data.water.length > 0) {
          this.iotData.water = data.water.map(item => ({
            name: '水浸',
            address: item[0] ? item[0].name : '',
            type: 'status',
            value: item.status || '正常',
            statusClass: (item.status === '正常' || item.status === '无水') ? 'success' : 'error',
            status: item.status || '正常',
            unit: '',
            location: item.location || ''
          }));
        }

        // 处理油锅数据（oil）
        if (data.oil && Array.isArray(data.oil) && data.oil.length > 0) {
          this.iotData.oil = data.oil.map(item => ({
            name: '油锅温度',
            address: item[0] ? item[0].name : '',
            type: 'status',
            num: item.num || '--',
            value:item.status || '正常',
            statusClass: item.status === '正常' ? 'success' : 'error',
            status: item.status || '正常',
            unit: '℃',
            location: item.location || ''
          }));
        }

        // 处理紫外线数据（ultraviolet）
        if (data.ultraviolet && Array.isArray(data.ultraviolet) && data.ultraviolet.length > 0) {
          this.iotData.ultraviolet = data.ultraviolet.map(item => ({
            name: '紫外线灯',
            address: item[0] ? item[0].name : '',
            type: 'status',
            value: item.status || '关闭',
            statusClass: item.status === '开启' ? 'error' : 'success',
            status: item.status || '关闭',
            unit: '',
            location: item.location || ''
          }));
        }

        // 处理二氧化碳数据（co2）
        if (data.co2 && Array.isArray(data.co2) && data.co2.length > 0) {
          this.iotData.co2 = data.co2.map(item => ({
            name: '二氧化碳',
            address: item[0] ? item[0].name : '',
            type: 'value',
            value: item.num || '0',
            statusClass: item.status === '正常' ? 'success' : 'error',
            status: item.status || '正常',
            unit: 'ppm',
            location: item.location || ''
          }));
        }

        // 处理动火离人数据（fireNoPerson）
        if (data.fireNoPerson && Array.isArray(data.fireNoPerson) && data.fireNoPerson.length > 0) {
          this.iotData.fireNoPerson = data.fireNoPerson.map(item => ({
            name: '动火离人',
            address: item[0] ? item[0].name : '',
            type: 'status',
            value: item.status || '正常',
            statusClass: item.status === '正常' ? 'success' : 'error',
            status: item.status || '正常',
            unit: '',
            location: item.location || ''
          }));
        }

        // 处理燃气数据（jiawan）
        if (data.jiawan && Array.isArray(data.jiawan) && data.jiawan.length > 0) {
          this.iotData.jiawan = data.jiawan.map(item => ({
            name: '燃气泄漏',
            address: item[0] ? item[0].name : '',
            type: 'value',
            value: item.num || '0',
            statusClass: item.status === '正常' ? 'success' : 'error',
            status: item.status === '正常',
            unit: '%LEL',
            location: item.location || ''
          }));
        }
        
      } catch (error) {
        console.error('获取IoT数据失败:', error);
      }
    },

    // 获取图标路径
    getIconSrc(name) {
      const iconMap = {
        '紫外线灯': require('../assets/image/ziwaixian.png'),
        '水浸': require('../assets/image/shuiyin.png'),
        '燃气泄漏': require('../assets/image/ranqi.png'),
        '油锅温度': require('../assets/image/youguo.png'),
        '二氧化碳': require('../assets/image/co2.png'),
        '动火离人': require('../assets/image/donghuo.png'),
        '温湿度': require('../assets/image/wd.png')
      };
      return iconMap[name] || '';
    },

    // 获取状态颜色类
    getStatusColor(status) {
      if (status === 'success' || status === 'normal') return 'status-green';
      if (status === 'warn') return 'status-orange';
      if (status === 'alarm' || status === 'error') return 'status-red';
      return '';
    },

    getStatusColor2(status) {
      if (status === '正常') return 'status-green';
      if (status === '警告') return 'status-orange';
      if (status === '报警' || status === '异常') return 'status-red';
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.iot-monitor-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.iot-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 5px 0;
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
}

/* 无数据提示 */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.no-data-img {
  width: 150px;
  height: 150px;
  opacity: 0.5;
}

.no-data-text {
  margin-top: 15px;
  font-size: 14px;
  color: #8899aa;
}

/* 单个显示样式 - 奇数多出的一个 */
.iot-single-display {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.iot-single-card {
  width: 90%;
  max-width: 400px;
  height: 120px;
  padding: 15px;
  box-sizing: border-box;
}

/* 轮播显示样式 */
.iot-carousel-display {
  width: 100%;
  padding: 5px;
  flex: 1;
  min-height: 180px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.iot-carousel {
  width: 100%;
  overflow: hidden;
}

.carousel-page {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  width: 100%;
}

/* IoT卡片样式 - 参考 largesScreen5.vue */
.iot-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  min-width: 0;
  padding: 10px 1px;
  border-radius: 4px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.carousel-page .iot-card {
  width: calc(33% - 2px);
  max-width: calc(33% - 7px);
  min-width: 0;
  min-height: 200px;
}



.tech-border-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid transparent;
  // box-shadow: 0 0 5px rgba(0, 210, 255, 0.1);
  pointer-events: none;
  border-radius: 4px;
}



.iot-icon-box {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.iot-name {
  font-size: 16px;
  color: #a0cfff;
  white-space: nowrap;
  height: 26px;
  line-height: 26px;
  margin-bottom: 6px;
  opacity: 0.9;
  flex-shrink: 0;
}

.iot-location {
  font-size: 14px;
  color: #fff;
  height: 22px;
  line-height: 22px;
  margin-bottom: 6px;
  opacity: 0.8;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  flex-shrink: 0;
}

/* 状态显示 */
.iot-status-only {
  height: 42px;
  line-height: 42px;
  margin-top: 6px;
  flex-shrink: 0;
}

.status-value-big {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.iot-value-box {
  height: 42px;
  line-height: 42px;
  margin-top: 6px;
  flex-shrink: 0;
}

.big-num {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 0 5px #00d2ff;
  flex-shrink: 0;
}

.unit {
  font-size: 14px;
  color: #aaa;
  margin-left: 3px;
}

/* 温湿度组合 */
.iot-temp-hum-box {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 42px;
  margin-top: 6px;
  width: 100%;
  justify-content: center;
  flex-shrink: 0;
}

.temp-hum-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.th-label {
  font-size: 13px;
  color: #8899aa;
  height: 18px;
  line-height: 18px;
  margin-bottom: 3px;
}

.th-value {
  font-size: 17px;
  font-weight: bold;
  height: 24px;
  line-height: 24px;
  flex-shrink: 0;
}

.th-value small {
  font-size: 12px;
  margin-left: 3px;
  opacity: 0.7;
}

.th-divider {
  width: 2px !important;
  height: 38px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.3), transparent);
  margin-bottom: 4px;
  flex-shrink: 0;
}

/* 状态颜色 */
.status-green {
  color: #00ff00;
  text-shadow: 0 0 5px rgba(0, 255, 0, 0.5);
}

.status-orange {
  color: orange;
  text-shadow: 0 0 5px rgba(255, 165, 0, 0.5);
}

.status-red {
  color: #ff3300;
  text-shadow: 0 0 5px rgba(255, 51, 0, 0.5);
}

/* 轮播图样式 */
::v-deep .el-carousel__container {
  height: 210px !important;
}

::v-deep .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.5) !important;
  width: 28px;
  height: 28px;
}

::v-deep .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

::v-deep .el-carousel__arrow i {
  font-size: 16px;
}

/* 帮助弹窗样式 */
::v-deep .el-dialog__header {
  background-color: #e4f1fe;
  font-weight: bold;
}

.help-content {
  padding: 10px;
}

.help-content h3 {
  margin: 0 0 15px 0;
  color: #333;
}

.simple-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.simple-table th,
.simple-table td {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  text-align: left;
}

.simple-table th {
  background-color: #f5f7fa;
  color: #303133;
  font-weight: bold;
}

/* 滚动条样式 */
.iot-container::-webkit-scrollbar {
  width: 6px;
}

.iot-container::-webkit-scrollbar-track {
  background: rgba(13, 22, 48, 0.2);
  border-radius: 3px;
}

.iot-container::-webkit-scrollbar-thumb {
  background: linear-gradient(
    to bottom,
    rgba(0, 210, 255, 0.7),
    rgba(0, 161, 255, 0.4)
  );
  border-radius: 3px;
  border: 1px solid rgba(0, 210, 255, 0.3);
}

.iot-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(
    to bottom,
    rgba(0, 255, 255, 0.9),
    rgba(0, 161, 255, 0.7)
  );
}

.digital-font {
  font-family: "Arial", sans-serif;
  letter-spacing: 0.5px;
}
</style>
